module.exports = __webpack_public_path__ + "img/web0.7e7e1a42.png";